import { memo, useState, type ReactNode } from 'react';
// Import Components
import CMSBannerInfo from './CMSBannerInfo';
import CMSBannerImagePreview from './CMSBannerImagePreview';
import RadioTabGroup from 'components/common/RadioTabGroup';
// Import Enums
import { DisplayModeEnum } from 'enums';
// Import Constants
import { ModeTabInfos } from 'constants/common';
// Import Styles
import styles from './templateModal.module.scss';

interface CMSBannerSectionProps {
    generalInfo: ReactNode;
    body: string;
}

const CMSBannerSection = ({ generalInfo, body }: CMSBannerSectionProps) => {
    const [displayMode, setDisplayMode] = useState<DisplayModeEnum>(DisplayModeEnum.LightMode);

    return (
        <>
            <div className={styles.cmsBannerInfoRow}>
                <div className={styles.cmsBannerInfoSection}>{generalInfo}</div>
                <div className={styles.cmsBannerInfoSection}>
                    <CMSBannerInfo body={body} />
                </div>
            </div>
            <div className={styles.cmsBannerPreviewToolbar}>
                <RadioTabGroup
                    activeTab={displayMode}
                    setActiveTab={(value: DisplayModeEnum) => setDisplayMode(value)}
                    tabs={ModeTabInfos}
                />
            </div>
            <CMSBannerImagePreview body={body} displayMode={displayMode} />
        </>
    );
};

export default memo(CMSBannerSection);
